import API from './api';

const roles = {
  roles: function (params, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: '/roles',
      params: params,
      interceptor: conInterceptor
    });
  }
};

export default roles;
